import {
  Box,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const DialogApprove = ({userActions, handleCloseConfirmDialog }) => {
  return (
    <>
      <DialogTitle
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          fontFamily: "Public Sans, sans-serif",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor:'#f2f2f2',
          marginBottom:'30px'
        }}
      >
        <Box display={"flex"} alignItems={"center"} gap={1}>
        <CheckCircleIcon sx={{color:'#67cd67'}}/>
        {userActions?.approveText+" - "+ userActions?.headerText}
        </Box>
        <IconButton onClick={handleCloseConfirmDialog}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to {userActions.approveText}?
        </DialogContentText>
      </DialogContent>
    </>
  );
};

export default DialogApprove;
